










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import CompanyActionRecommendEditForm from '@/components/settings/company_action_recommend/EditForm.vue';

@Component({
  components: {
    Header,
    CompanyActionRecommendEditForm,
    Footer,
  },
})
export default class CompanyActionRecommendEditPage extends Vue {}
